'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _dialogColor = require('./dialogColor');

var _dialogColor2 = _interopRequireDefault(_dialogColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogButton = function () {
    function DialogButton(text, btnClass, callback) {
        (0, _classCallCheck3.default)(this, DialogButton);

        this.text = text;
        if (btnClass) {
            this.btnClass = 'btn-' + btnClass;
        }
        this.callback = callback;
    }

    (0, _createClass3.default)(DialogButton, null, [{
        key: 'new',
        value: function _new(text, btnClass, callback) {
            return new DialogButton(text, btnClass, callback);
        }
    }, {
        key: 'ok',
        value: function ok() {
            return new DialogButton('OK', null, null);
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            return new DialogButton('CANCEL', null, null);
        }
    }]);
    return DialogButton;
}();

exports.default = DialogButton;


// WEBPACK FOOTER //
// ./client/app/common/models/dialog/dialogButton.js